// extracted by mini-css-extract-plugin
module.exports = {"amp-first-grid":"styles-m__amp-first-grid__3RtQR","amp-section":"styles-m__amp-section__2GzEg","footer-title":"styles-m__footer-title__1rs3Q"};